import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Swal from 'sweetalert2'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormGroup,
  Label,
  Nav,
  NavItem
} from "reactstrap"
import primg1 from "../../assets/images/project/img1.jpg"
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PropTypes from "prop-types";
import deleteIcon from "../../assets/images/icons/bin.png";
import { get, post } from "helpers/api_helper";
import Moment from "react-moment";
import { toast } from "react-toastify";
import { API_URL } from "helpers/api_url";
import project from "./project";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import { setupInactivityTimer } from "../../helpers/api_helper";
import projectIcon from "../../assets/img/project-icon.png"
import favIcon from "../../assets/img/fav-icon.png"
import transIcon from "../../assets/img/transaction-icon.png"
class myTransection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      transaction:'',
      transactions:[],
      existingSchedules: [],
      agentClientTransactionPaymentSchedule: [{ agentId: "", clientId: "", dealRefId: "", paymentDate: "", paymentAmount:'', bankDetail:'', chequeDetail:'', paymentNotificationBeforeDays:"" }]
    }
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.handelSubmitPayment = this.handelSubmitPayment.bind(this);
    
  }
  componentDidMount() {
      setupInactivityTimer();
            
      const clientId = localStorage.getItem('userId');
      const agentId = localStorage.getItem('agentId');
      get(`ClientEngagement/allbyclient`, {
        params: {
          clientId: clientId,
          agentId: agentId
        }
      })
      .then(res => {
        const transactions = res;
        this.setState({ transactions });
      })
      .catch((error) => {
        console.error("Error fetching transactions:", error);
        this.setState({ error: error.message });
      });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleRightCanvas() {
    this.setState({transaction: "", isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const transaction = arg;
  
    this.setState({
      transaction: {
        id:transaction.id,
        dealRefId:transaction.dealRefId,
        projectId:transaction?.projectInfo?.id,
      }
    });
    this.fetchPayments(transaction.id);
    this.toggle();
  };
  handelSubmitPayment = async (values) => {
    try {
      const transformedValues = {
        agentClientTransactionPaymentSchedules: values.agentClientTransactionPaymentSchedules.map((item) => ({
          ...item,
          paymentAmount: parseInt(item.paymentAmount) || 0,
          paymentNotificationBeforeDays: parseInt(item.paymentNotificationBeforeDays) || 0,
          agentId: parseInt(item.agentId) || 0,
          clientId: parseInt(item.clientId) || 0,
          dealRefId: parseInt(item.dealRefId) || 0,
          engagementId: parseInt(item.engagementId) || 0,
          projectId: parseInt(item.projectId) || 0,
          paymentDate:moment(item.paymentDate).format("YYYY-MM-DD"),
        }))
      };
      toast.loading("Please wait...");
      const response = await post(
       `AgentClientTransactionPaymentSchedule/bulkadd`,
       transformedValues
      );
      if (response) {
        toast.dismiss();
        toast.success("Payment schedule submitted successfully!");
        this.toggle();
        //this.fetchPayments(this.state.transaction.id);
      } else {
        console.warn("Something went wrong!", response);
      }
    } catch (error) {
      console.error("Error submitting payment schedule:", error);
      // Show error message to user
    }
  };
   fetchPayments(TransactionId){
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json",
        };
    
        const params = {
          TransactionId: TransactionId,
          ClientId: localStorage.getItem('userId'),
          AgentId:localStorage.getItem('agentId')
        };
        axios
        .get(`${API_URL}AgentClientTransactionPaymentSchedule/allAgent`, { headers, params })
        .then((response) => {
         
          this.setState({ 
            paymentLists: response.data, 
           
          });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
    deletePayment = (payment) => {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
         
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj?.resultData?.bearerToken;
          axios
          .delete(`${API_URL}AgentClientTransactionPaymentSchedule/${payment.id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", "Payment Schedule has been deleted.", "success");
            this.fetchPayments(payment.engagementId);
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the payment.", "error");
          });
        }
      });
    }
  render() {
    const { transaction } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Project | Realty Space</title>
          </MetaTags>
          <Container fluid>
             <Row className="justify-content-between align-items-center mb-4">
                <Col sm="12">
                  <Nav tabs className="projectTab pref-tab">
                    <NavItem>
                      <Link className="nav-link " to="/project">
                        <span className="d-flex align-items-center gap-2">
                          All Projects
                          <img src={projectIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link " to="/my-interests">
                        <span className="d-flex align-items-center gap-2">My Favorites

                           <img src={favIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link active" to="/my-transection">
                         <span className="d-flex align-items-center gap-2">My Transactions

                          <img src={transIcon} height={16} />
                         </span>
                      </Link>
                    </NavItem>
                  </Nav>
                </Col>
              </Row>
        
          <Breadcrumbs
              title="Projects"
              breadcrumbItem="Transactions"
            />
        
            <Row>
                 <Col sm="12">
                   <Card>
                     <CardBody>
                     <div className="table-responsive">
                    <Table className="table align-middle table-nowrap mb-0">
                      <thead>
                        <tr>
                          
                        
                         
                          <th scope="col">Project</th>
                         
                        
						              <th scope="col">Cost</th>
                          <th scope="col">Closing Date</th>
                          <th scope="col"></th>
                          
                         
                        </tr>
                      </thead>
                      <tbody>
                      {
                            this.state.transactions
                              .map(transaction =>
                       <tr key={transaction.id}>
                       {/* <td><img src={primg1} className="img-fluid" width="100" /></td> */}
                         <td>{transaction.projectInfo?.projectName}</td>
                        
                         <td><CurrencyFormat value={transaction.transactionAmount} displayType={'text'} thousandSeparator={true} prefix={transaction?.currencyCode + " "} /></td>
                         <td><Moment format="Do MMMM YYYY">{transaction.closingDate}</Moment></td>
                         <td><Link to={`/project-detail/${transaction.projectInfo?.id}/${transaction.projectInfo?.projectGuid}`} className="btn btn-primary">Detail</Link>{" "} </td>

                       </tr>
                  )}
                      </tbody>
                    </Table>
                    {/* <Link to="#" onClick={() => this.toggleRightCanvas(transaction)} className="btn btn-primary">Payment Schedule</Link> */}
                  </div>

                     </CardBody>
                   </Card>
               

              </Col>
              
            </Row>


            <Offcanvas
                      isOpen={this.state.isRight}
                      direction="end"
                      toggle={this.toggleRightCanvas}
                      style={{width:800}}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvas}>
                      Payment Schedule
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Formik
        enableReinitialize={true}
        initialValues={{
          agentClientTransactionPaymentSchedules: [
            {
              projectId:transaction?.projectId,
              engagementId:transaction?.id,
              agentId: localStorage.getItem('agentId'),
              clientId: localStorage.getItem('userId'),
              dealRefId: transaction?.dealRefId,
              paymentDate: '',
              paymentAmount: 0,
              bankDetail: '',
              chequeDetail: '',
              paymentNotificationBeforeDays: 0
            }
          ]
        }}
        validationSchema={Yup.object().shape({
          agentClientTransactionPaymentSchedules: Yup.array().of(
            Yup.object().shape({
              paymentDate: Yup.string().required("This is required"),
              paymentAmount: Yup.number()
                .typeError("Price should be a number")
                .required("Amount is required")
            })
          )
        })}
        onSubmit={this.handelSubmitPayment}
      >
        {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
          <Form className="needs-validation">
            <FieldArray
              name="agentClientTransactionPaymentSchedules"
              render={(arrayHelpers) => (
                <div>
                  {values.agentClientTransactionPaymentSchedules.map((paymentSchedule, index) => (
                    <div key={index}>
                      <Row>
                        <Col sm="2">
                          <FormGroup className="mb-3">
                            <Label htmlFor="paymentDate" className="label-text mt-3">
                              Date *
                            </Label>
                            <Flatpickr
                              className={`form-control ${
                                errors.agentClientTransactionPaymentSchedules?.[index]?.paymentDate &&
                                touched.agentClientTransactionPaymentSchedules?.[index]?.paymentDate
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={paymentSchedule.paymentDate}
                              onChange={(date) =>
                                setFieldValue(
                                  `agentClientTransactionPaymentSchedules.${index}.paymentDate`,
                                  date[0]
                                )
                              }
                              options={{
                                altInput: true,
                                altFormat: "Y-m-d",
                                dateFormat: "Y-m-d"
                              }}
                            />
                            <ErrorMessage
                              name={`agentClientTransactionPaymentSchedules.${index}.paymentDate`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="2">
                          <FormGroup className="mb-3">
                            <Label htmlFor="paymentAmount" className="label-text mt-3">
                              Amount
                            </Label>
                            <input
                              type="text"
                              name={`agentClientTransactionPaymentSchedules.${index}.paymentAmount`}
                              value={paymentSchedule.paymentAmount}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${
                                errors.agentClientTransactionPaymentSchedules?.[index]?.paymentAmount &&
                                touched.agentClientTransactionPaymentSchedules?.[index]?.paymentAmount
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              name={`agentClientTransactionPaymentSchedules.${index}.paymentAmount`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="2">
                          <FormGroup className="mb-3">
                            <Label htmlFor="bankDetail" className="label-text mt-3">
                              Bank
                            </Label>
                            <input
                              type="text"
                              name={`agentClientTransactionPaymentSchedules.${index}.bankDetail`}
                              value={paymentSchedule.bankDetail}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${
                                errors.agentClientTransactionPaymentSchedules?.[index]?.bankDetail &&
                                touched.agentClientTransactionPaymentSchedules?.[index]?.bankDetail
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              name={`agentClientTransactionPaymentSchedules.${index}.bankDetail`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="2">
                          <FormGroup className="mb-3">
                            <Label htmlFor="chequeDetail" className="label-text mt-3">
                              Cheque #
                            </Label>
                            <input
                              type="text"
                              name={`agentClientTransactionPaymentSchedules.${index}.chequeDetail`}
                              value={paymentSchedule.chequeDetail}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${
                                errors.agentClientTransactionPaymentSchedules?.[index]?.chequeDetail &&
                                touched.agentClientTransactionPaymentSchedules?.[index]?.chequeDetail
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              name={`agentClientTransactionPaymentSchedules.${index}.chequeDetail`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label
                              htmlFor={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                              className="label-text mt-3"
                            >
                              Notify me
                            </Label>
                            <Field
                              as="select"
                              name={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                              className={`form-control ${
                                errors.agentClientTransactionPaymentSchedules?.[index]?.paymentNotificationBeforeDays &&
                                touched.agentClientTransactionPaymentSchedules?.[index]?.paymentNotificationBeforeDays
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={handleChange}
                            >
                              <option value="">Select</option>
                              <option value="1">1 day before</option>
                              <option value="7">1 week before</option>
                              <option value="14">2 weeks before</option>
                              <option value="30">1 month before</option>
                            </Field>
                            <ErrorMessage
                              name={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="1">
                          <div className="clearfix">
                            {index === 0 ? (
                              <button
                                type="button"
                                onClick={() =>
                                  arrayHelpers.push({
                                    ...defaultSchedule,
                                    dealRefId: transaction.id
                                  })
                                }
                                style={{ marginTop: 42 }}
                                className="btn btn-add"
                              >
                                <i className="bx bx-plus-medical" />
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={() => arrayHelpers.remove(index)}
                                style={{ marginTop: 42 }}
                                className="btn btn-remove"
                              >
                                <i className="bx bx-minus" />
                              </button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
            />
            <Col sm="2">
              <div className="clearfix">
                <button
                  type="submit"
                  className="btn btn-primary w-md"
                  style={{ marginTop: 2 }}
                >
                  Save
                </button>
              </div>
            </Col>
          </Form>
        )}
                      </Formik>
                    <h5 style={{marginTop:40}}>Existing schedules</h5>
                    <div className="table-responsive">
                    <Table className="table align-middle table-nowrap mb-0">
                      <thead>
                        <tr>
                          
                     
                         
                          <th scope="col">Date </th>
                         
                          <th scope="col">Amount</th>
						              <th scope="col">Bank</th>
                          <th scope="col">Chq #</th>
                          <th scope="col"></th>
                          
                         
                        </tr>
                      </thead>
                      <tbody>
                      {    this.state.paymentLists &&
                            this.state.paymentLists
                              .map(payment =>
                       <tr key={payment.id}>
                      
                         <td><Moment format="Do MMMM YYYY">{payment.paymentDate}</Moment></td>
                        
                         <td><CurrencyFormat value={payment.paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'USD '} /></td>
                         <td>{payment.bankDetail}</td>
                         <td>{payment.chequeDetail}</td>
                         <td><Link to="#" onClick={() => this.deletePayment(payment)} className=""><img src={deleteIcon} style={{width:30}} alt="" /></Link></td>
                       </tr>
                  )}
                      </tbody>
                    </Table>
                    
                    </div>
                      </OffcanvasBody>
                    </Offcanvas>
            

          </Container>
        </div>
      </React.Fragment>
    )
  }
}
myTransection.propTypes = {
  t: PropTypes.any

}
export default connect()(withTranslation()(myTransection))
